import { NgModule } from '@angular/core';
import { ImportDefinitionService } from '../services/import-definition.service';

@NgModule({
  providers: [ImportDefinitionService],
})
export class ImportDefinitionModule {}
